<template>
    <div class="more-recode" @click="getMore">
        {{text}}
    </div>
</template>

<script>
    export default {
        name: "GoMore",
        props: {
            text: { type: String, default:'更多信息'},
            jumpUrl:  { type: String, default:''},
            jumRouter:{ type: String, default:''},
        },
        methods:{
            getMore(){
                if(!this.jumpUrl) {
                    if(!this.jumRouter) {
                        this.$message.error('无详情地址!');
                        return false;
                    }
                    this.$router.push({name:this.jumRouter})
                    return false;
                }
                window.open(this.jumpUrl);
            }
        }
    }
</script>

<style scoped lang="scss">
    .more-recode {
        text-align: right;
        font-size: 12px;
        color: #3a3550;
        padding: 10px 31px 10px 0;
        cursor: pointer;
    }
</style>